import React from "react";
import { Container } from "react-bootstrap";
// 导入认证上下文提供者，确保整个应用内能访问认证状态和方法
import { AuthProvider } from "../../contexts/AuthContext";
// 导入 React Router 相关 API，用于定义路由
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// 导入各个页面组件
import Signup from "./Signup";
import Dashboard from "./Dashboard";
import Login from "./Login";
import PrivateRoute from "./PrivateRoute";
import ForgotPassword from "./ForgotPassword";
import UpdateProfile from "./UpdateProfile";

// App 组件：作为整个应用的根组件
// open 属性用于控制是否渲染 App 组件（例如用于模态显示或条件渲染）
const App = ({ open }) => {
  // 如果 open 为 false，则不渲染任何内容
  if (!open) return null;

  return (
    // 使用 Container 组件对内容进行居中布局，最小高度为整个视口高度
    <Container
      className="d-flex align-items-center justify-content-center"
      style={{ minHeight: "100vh" }}
    >
      {/* 限制内容宽度，保持在 400px 内 */}
      <div className="w-100" style={{ maxWidth: "400px" }}>
        {/* 使用 Router 包裹所有路由 */}
        <Router>
          {/* 使用 AuthProvider 包裹整个路由树，提供认证上下文 */}
          <AuthProvider>
            {/* 定义路由配置 */}
            <Routes>
              {/* 根路径：使用 PrivateRoute 包裹 Dashboard，只有认证用户才能访问 */}
              <Route
                path="/"
                element={
                  <PrivateRoute>
                    <Dashboard />
                  </PrivateRoute>
                }
              />
              {/* 更新资料页面，同样需要认证用户访问 */}
              <Route
                path="/update-profile"
                element={
                  <PrivateRoute>
                    <UpdateProfile />
                  </PrivateRoute>
                }
              />
              {/* 注册、登录、重置密码页面不需要认证，直接渲染相应组件 */}
              <Route path="/signup" element={<Signup />} />
              <Route path="/login" element={<Login />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
            </Routes>
          </AuthProvider>
        </Router>
      </div>
    </Container>
  );
};

export default App;